import Model from "./base/model";

class VehicleOption extends Model {
  resourceName() {
    return "vehicle_options";
  }

  fields() {
    return {
      vehicle_option: "",
      vehicle_type_id: "",
    };
  }
}

export default new VehicleOption();
